import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { CronsService } from '../crons.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';
import { helper } from 'src/environments/helper';

@Component({
    selector: 'app-edit-crons',
    templateUrl: './edit-crons.component.html',
    styleUrls: ['./edit-crons.component.scss']
})
export class EditCronsComponent {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    activeOptions = [
        { label: 'Da', value: 1 },
        { label: 'Nu', value: 0 },
    ];

    form: FormGroup = new FormGroup({
        id: new FormControl(this.data.id, Validators.required),
        name: new FormControl(this.data.name, Validators.required),
        path: new FormControl(this.data.path, Validators.required),
        slug: new FormControl(this.data.slug, Validators.required),
        interval: new FormControl(this.data.interval, Validators.required),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditCronsComponent>,
        private cronsService: CronsService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.cronsService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const updatedCronsData = {
            id: this.data.id,
            name: this.form.get('name')?.value,
            slug: this.form.get('slug')?.value,
            path: this.form.get('path')?.value,
            interval: this.form.get('interval')?.value
        };

        this.cronsService
            .updateCrons(updatedCronsData)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    console.log(updatedCronsData);
                    this.dialogRef.close({ success: true });
                },
                error: () => {
                    console.log(updatedCronsData);
                    let errorMessage =
                        environment.config.customNotifications.generalMessages.error;
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                },
            });
    }
}
